import { ChangeEventHandler, FunctionComponent } from 'react';
import '../css/AppHome.css';
import GenericIcons from './generics/GenericIcons';

const CheckBox: FunctionComponent<{
  label: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  checked?: boolean;
  disabled?: boolean;
  icon?: string;
}> = ({ label, onChange, checked, disabled, icon }) => {
  return (
    <label
      className={`primary-checkbox-style ${disabled ? 'primary-checkbox-disabled-style' : ''}`}>
      {icon && <GenericIcons icon={icon} imageStyle={{ height: '1.8vw' }} />}
      {label}
      <input
        className={`primary-checkbox-input-style ${
          disabled ? 'primary-checkbox-input-disabled-style' : ''
        }`}
        disabled={disabled}
        type='checkbox'
        checked={checked}
        onChange={onChange}
      />
      <span
        className={`primary-checkbox-checkmark-style ${
          disabled ? 'primary-checkbox-checkmark-disabled-style' : ''
        }`}></span>
    </label>
  );
};

export default CheckBox;
